import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TravelAuthorizationComponent } from './components/travel-authorization/travel-authorization.component';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule, MatAutocompleteModule, MatCheckboxModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatTabsModule, MatSelectModule, MatDatepicker, MatDatepickerModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TravelService } from './services/travel/travel.service';
import { TravelAuthorizationViewComponent } from './components/travel-authorization-view/travel-authorization-view.component';
import { TravelAuthorizationAddComponent } from './components/travel-authorization-add/travel-authorization-add.component';
import { TravelSummaryAddComponent } from './components/travel-summary-add/travel-summary-add.component';
import { TravelSummaryViewComponent } from './components/travel-summary-view/travel-summary-view.component';
import { TravelBookingAddComponent } from './components/travel-booking-add/travel-booking-add.component';
import { TravelBookingViewComponent } from './components/travel-booking-view/travel-booking-view.component';
import { TravelAuthorizationCancelComponent } from './components/travel-authorization-cancel/travel-authorization-cancel.component';
import { TravelApproverComponent } from './components/travel-approver/travel-approver.component';
import { TravelApproverViewComponent } from './components/travel-approver-view/travel-approver-view.component';

@NgModule({
  declarations: [
    TravelAuthorizationComponent,
    TravelAuthorizationViewComponent,
    TravelAuthorizationAddComponent,
    TravelSummaryAddComponent,
    TravelSummaryViewComponent,
    TravelBookingAddComponent,
    TravelBookingViewComponent,
    TravelAuthorizationCancelComponent,
    TravelApproverComponent,
    TravelApproverViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTabsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule
  ],
  providers:[    
    TravelService
  ],
  entryComponents:[
    TravelAuthorizationViewComponent,
    TravelAuthorizationAddComponent,
    TravelSummaryAddComponent,
    TravelSummaryViewComponent,
    TravelBookingAddComponent,
    TravelBookingViewComponent,
    TravelAuthorizationCancelComponent,
    TravelApproverViewComponent
  ]
})
export class TravelModule { }
